import type { Dict } from './en';

export const de: Dict = {
  appTagline: 'Offener Live-Flugtracker',
  search: 'Flug, Kennzeichen, Hex oder Flughafen suchen',
  searchNoResults: 'Weder in der Nähe noch im Netzwerk etwas gefunden.',
  searchUpstream: 'Netzwerk wird durchsucht…',
  filters: 'Filter',
  layers: 'Karte',
  settings: 'Einstellungen',
  about: 'Info & Daten',
  close: 'Schließen',
  aircraft: 'Flugzeuge',
  inView: 'sichtbar',
  ground: 'Boden',
  altitude: 'Höhe',
  geoAltitude: 'GPS-Höhe',
  speed: 'Geschwindigkeit über Grund',
  vs: 'Steig-/Sinkrate',
  track: 'Kurs',
  squawk: 'Squawk',
  registration: 'Kennzeichen',
  type: 'Typ',
  category: 'Kategorie',
  hex: 'ICAO 24-Bit',
  source: 'Positionsquelle',
  positionAge: 'Alter der Position',
  provider: 'Datenquelle',
  route: 'Route',
  routeUnknown: 'Für dieses Rufzeichen ist keine Route bekannt.',
  routeImplausible: 'Für dieses Rufzeichen ist eine Route bekannt, sie passt aber nicht zur aktuellen Position und wird daher ausgeblendet.',
  routeNote: 'Übliche Route dieses Rufzeichens (Community-Daten). Kein Live-Flugplan.',
  follow: 'Folgen',
  unfollow: 'Nicht mehr folgen',
  share: 'Link kopieren',
  copied: 'Link kopiert',
  trail: 'Die Spur zeigt Positionen seit Beginn der Beobachtung.',
  emergency: 'Notfall',
  military: 'Militär',
  noCallsign: 'Kein Rufzeichen',
  zoomIn: 'Hineinzoomen, um Flugzeuge für den ganzen Bereich zu laden. Es wird nur die Mitte angezeigt.',
  stale: 'Live-Daten verzögert: Das Community-Netzwerk drosselt oder ist nicht erreichbar. Letzte bekannte Positionen werden angezeigt.',
  offline: 'Du bist offline. Positionen werden fortgesetzt, sobald die Verbindung zurück ist.',
  loading: 'Live-Flugzeuge werden geladen…',
  errorData: 'Die Skywake-API ist nicht erreichbar.',
  apiNotConfigured: 'Für diesen Build ist keine Live-Daten-API konfiguriert, daher können keine Flugzeuge angezeigt werden.',
  retry: 'Erneut versuchen',
  dataAge: 'Datenalter',
  providerStatus: 'Status der Datenquelle',
  ok: 'OK',
  degraded: 'Eingeschränkt',
  theme: 'Design',
  themeAuto: 'System',
  themeLight: 'Hell',
  themeDark: 'Dunkel',
  units: 'Einheiten',
  language: 'Sprache',
  labels: 'Rufzeichen-Beschriftungen',
  airports: 'Flughäfen',
  trails: 'Spur des ausgewählten Flugzeugs',
  colorBy: 'Flugzeuge färben nach',
  colorAlt: 'Höhe',
  colorSource: 'Positionsquelle',
  altMin: 'Min. Höhe (ft)',
  altMax: 'Max. Höhe (ft)',
  speedMin: 'Min. Geschwindigkeit (kt)',
  speedMax: 'Max. Geschwindigkeit (kt)',
  callsignPrefixes: 'Airline-/Rufzeichen-Präfixe',
  callsignPrefixesHint: 'Kommagetrennt, z. B. DLH, EWG, RYR',
  types: 'Flugzeugtypen',
  typesHint: 'ICAO-Codes, * als Platzhalter, z. B. A32*, B738',
  hideGround: 'Flugzeuge am Boden ausblenden',
  onlyEmergency: 'Nur Notfälle (7500/7600/7700)',
  onlyMilitary: 'Nur Militär',
  sources: 'Positionsquellen',
  presets: 'Gespeicherte Vorlagen',
  presetName: 'Name der Vorlage',
  savePreset: 'Aktuelle Filter speichern',
  apply: 'Anwenden',
  delete: 'Löschen',
  clearFilters: 'Filter zurücksetzen',
  filtered: 'gefiltert',
  airport: 'Flughafen',
  elevation: 'Höhe über NN',
  nearbyTraffic: 'Verkehr im Umkreis von 30 km',
  noNearby: 'Derzeit keine erfassten Flugzeuge in der Nähe dieses Flughafens.',
  viewOnOurAirports: 'Auf OurAirports ansehen',
  bookmarks: 'Lesezeichen',
  bookmarkView: 'Diese Ansicht merken',
  watchlist: 'Beobachten',
  watching: 'Beobachtet',
  alerts: 'Benachrichtigungen',
  alertsEmergency: 'Bei Notfall-Squawks im sichtbaren Bereich benachrichtigen',
  alertsWatch: 'Benachrichtigen, wenn beobachtete Flugzeuge auftauchen',
  alertsPermissionDenied: 'Benachrichtigungen sind im Browser blockiert. Hinweise erscheinen nur in der App.',
  emergencyAlert: 'Notfall-Squawk',
  watchAlert: 'Beobachtetes Flugzeug entdeckt',
  adsb: 'ADS-B',
  mlat: 'MLAT',
  tisb: 'TIS-B',
  adsr: 'ADS-R',
  modes: 'Mode S',
  other: 'Sonstige',
  attribution: 'Flugzeugdaten: ADSB.lol-Mitwirkende (ODbL 1.0). Routen: VRS standing data (CC0). Flughäfen: OurAirports (gemeinfrei). Fotos: Fotografen von Planespotters.net (bei jedem Foto genannt). Wetter: NOAA Aviation Weather Center (gemeinfrei).',
  aboutBody:
    'Skywake ist freie Open-Source-Software. Die Positionen stammen von ehrenamtlich betriebenen ADS-B-Empfängern und werden von ADSB.lol gebündelt. Die Abdeckung hängt davon ab, wo Freiwillige Empfänger betreiben. Keine Konten, keine Werbung, keine Tracking-Cookies. Deine Einstellungen bleiben auf diesem Gerät.',
  limitations: 'Bekannte Einschränkungen',
  limitationsList:
    'Noch kein Flugverlauf und keine Wiedergabe: Skywake zeigt nur, was seit dem Öffnen empfangen wurde.|Routen stammen aus einer Community-Datenbank und können falsch oder veraltet sein.|Über Ozeanen und in Regionen mit wenigen Empfängern ist die Abdeckung dünn.|Flugzeuge, deren Halter Privatsphäre beantragt haben (z. B. LADD/PIA), können ausgeblendet oder anonymisiert sein.',
  sourceCode: 'Quellcode',
  feedData: 'Einen Empfänger betreiben und ADSB.lol beliefern',
  version: 'Version',
  webglMissing: 'Dein Browser kann die Live-Karte nicht darstellen (WebGL2 nicht verfügbar).',
  selectedOutOfCoverage: 'Dieses Flugzeug wird nicht mehr empfangen.',
  emergencies: 'Notfälle',
  compare: 'Vergleichen',
  list: 'Liste',
  sortBy: 'Sortieren nach',
  callsign: 'Rufzeichen',
  locate: 'Mein Standort',
  photoAlt: 'Foto des Flugzeugs {reg}',
  weather: 'Wetter (METAR)',
  weatherUnavailable: 'Wetterdaten sind derzeit nicht verfügbar.',
  weatherNone: 'Dieser Flughafen veröffentlicht kein METAR.',
  weatherSource: 'NOAA Aviation Weather Center. Nicht für die Flugplanung.',
  wind: 'Wind',
  calm: 'Windstill',
  variable: 'Umlaufend',
  gusts: 'Böen',
  visibility: 'Sicht',
  temperature: 'Temp. / Taupunkt',
  clouds: 'Wolken',
  observed: 'Alter der Meldung',
  legFlown: 'geflogen',
  legToGo: 'verbleibend',
  legEta: 'Ankunft',
  legNote: 'Großkreis-Schätzung aus der üblichen Route und der aktuellen Geschwindigkeit.',
};
